import React from "react";
import { useAppSelector } from "hooks/redux";
import { selectors } from "store/patientDetail";
import { UploadedFilesTable } from "./UploadedFilesTable";

export const UploadedFiles = () => {
  const isLoading = useAppSelector(selectors.isLoading);
  return <UploadedFilesTable loading={isLoading} />;
};
